import { render, staticRenderFns } from "./platimage.vue?vue&type=template&id=92bb6f62&scoped=true&"
import script from "./platimage.vue?vue&type=script&lang=js&"
export * from "./platimage.vue?vue&type=script&lang=js&"
import style0 from "./platimage.vue?vue&type=style&index=0&id=92bb6f62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bb6f62",
  null
  
)

export default component.exports